<template>
	<div class="settlement-list">
		<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="seachSettleMentList">
			<el-form-item label="户号">
				<el-input v-model="select.account" placeholder="户号" :maxlength="12" style="width:150px"></el-input>
			</el-form-item>
			<el-form-item label="表号">
				<el-input v-model="select.code" placeholder="表号" :maxlength="12" style="width:150px"></el-input>
			</el-form-item>
			<el-form-item label="状态">
				<el-select v-model="select.nature" placeholder="请选择" style="width: 150px;">
					<el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="业主手机号">
				<el-input v-model="select.iphone" placeholder="手机号" :maxlength="12" style="width:150px"></el-input>
			</el-form-item>
				<el-button type="primary" @click="seachSettleMentList">查询</el-button>
				<el-button type="primary" @click="returnSearch">重置</el-button>
				<el-button type="primary" @click="downLoad">导出</el-button>
				<el-button type="primary" @click="returnList">返回</el-button>
			</el-form-item>
	</el-form>
	<el-table :data="meterList" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;margin-top: 10px;">
			<el-table-column prop="account" label="户号" width="180" align="center" >
			</el-table-column>
			<el-table-column prop="code" label="表号" width="180" align="center" >
			</el-table-column>
			<el-table-column prop="phone" label="业主手机号" width="180" align="center" >
			</el-table-column>
			<el-table-column prop="name" label="业主姓名" width="180" align="center">
			</el-table-column>
			<el-table-column prop="type" label="业主类型" width="180" align="center">
			</el-table-column>
			<el-table-column prop="years" label="年份" width="180" align="center">
			</el-table-column>
			<el-table-column prop="annual" label="年用量" width="180" align="center">
			</el-table-column>
			<el-table-column prop="month_money" label="月阶梯年用金额（元）" width="180" align="center">
			</el-table-column>
			<el-table-column prop="years_money" label="年阶梯用金额（元）" width="180" align="center">
			</el-table-column>
			<el-table-column prop="refund_money" label="阶梯应退费（元）" width="180" align="center">
			</el-table-column>
			<el-table-column prop="actual_money" label="阶梯实际退费（元）" width="180" align="center">
			</el-table-column>
			<el-table-column prop="status" label="状态" width="180" align="center">
			</el-table-column>
			<el-table-column prop="order_id" label="订单号" width="180" align="center">
			</el-table-column>
			<el-table-column prop="refund_time" label="创建时间" width="180" align="center">
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
		</el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'settlement-list',
		data() {
			return {
				select:{
					code:'',
					account: '',
					nature:'',
					iphone:'',
				},
				pageSize:15,
				total:0,
				page:0,
				prop:'',
				order:'',
				natures:[
					{
						num:'3',
						value:'退费成功',
					},
					{
						num:'-3',
						value:'退费失败'
					},
					{
						num:'2',
						value:'处理中'
					},
					{
						num:'1',
						value:'未退费'
					},
				],
				meterList:[
					{
						
					},
				],
				
			}
		},
		created:function(){
			this.seachSettleMentList()
		},
		methods:{
			seachSettleMentList(){
				this.$jssdk.refund.info({
					year:this.$route.params.year,
					community_id:this.$route.params.build,
					page:this.page,
					meter_code:this.select.code,
					account: this.select.account,
					phone:this.select.iphone,
					status:this.select.nature,
					is_export:'0'
				},(res) =>{
					this.meterList = res.data
					this.total = res.total
					console.log(res)
				},(err) =>{
					this.$message({
						type:'warning',
						message:err.data,
						duration:2000
					})
				})
			},
			returnSearch(){
				this.select.account = ''
				this.select.code = ''
				this.select.nature = ''
				this.select.iphone = ''
			},
			downLoad(){
				this.$jssdk.refund.info({
					year:this.$route.params.year,
					community_id:this.$route.params.build,
					page:this.page,
					meter_code:this.select.code,
					account: this.select.account,
					phone:this.select.iphone,
					status:this.select.nature,
					is_export:'1'
				},(res) =>{
					window.location.href = res.url
				},(err) =>{
					this.$message({
						type:'warning',
						message:err.data,
						duration:2000
					})
				})
			},
			returnList(){
				this.$router.push({name:'settlement'})
			},
			sortChange(item){
				var order = item.order
				var prop = item.prop
				this.prop = prop
				this.order = order
				
			},
			handleSizeChange(val){
				
			},
			handleCurrentChange(val){
				this.page = val
				this.$jssdk.refund.info({
					year:this.$route.params.year,
					community_id:this.$route.params.build,
					page:val,
					meter_code:this.select.code,
					account: this.select.account,
					phone:this.select.iphone,
					status:this.select.nature,
					is_export:'0'
				},(res) =>{
					this.meterList = res.data
					this.total = res.total
				},(err) =>{
					this.$message({
						type:'warning',
						message:err.data,
						duration:2000
					})
				})
			}
		},
		watch:{
			
		},
	}
	
</script>
<style>
</style>


// WEBPACK FOOTER //
// settlementList.vue?3f43ac46